export default function Toast({ mensaje, onClose }) {
  if (!mensaje) return null;

  return (
    <div className="fixed top-5 right-5 z-50">
      <div className="bg-green-500 text-white px-4 py-2 rounded shadow-lg animate-bounce dark:bg-green-700">
        {mensaje}
        <button
          onClick={onClose}
          className="ml-3 font-bold hover:text-gray-200"
        >
          ✕
        </button>
      </div>
    </div>
  );
}
